import React, { useRef } from "react";
import { Body, Container, EntryAnimation, Heading } from "../../atoms";
import { LabeledCallToAction, SimpleCardRow } from "../../molecules";
export default function SimpleCardRowsSection(param) {
    var title = param.title, description = param.description, rows = param.rows, _param_actions = param.actions, actions = _param_actions === void 0 ? [] : _param_actions, className = param.className;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: SimpleCardRowsSection.name,
        background: "subtle",
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-md"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center"
    }, !!title && /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h2"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "prose prose-neutral"
    }, description)), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-3"
    }, rows.map(function(row, rowIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "card-".concat(row.title),
            view: containerRef,
            delay: rowIndex / 10
        }, /*#__PURE__*/ React.createElement(SimpleCardRow, row));
    })), !!actions.length && /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-5 grid-cols-1 grid-flow-row auto-rows-max md:grid-cols-2 md:mt-7 md:gap-7 lg:gap-10"
    }, actions.map(function(action) {
        return /*#__PURE__*/ React.createElement(LabeledCallToAction, {
            key: "action-".concat(action.label),
            label: action.label,
            action: action.action,
            contentClassName: "bg-subtle-700"
        });
    })))));
}

//# sourceMappingURL=SimpleCardRowsSection.js.map